module.exports = __webpack_public_path__ + "static/media/delete-icon.3798f238.svg";